// extracted by mini-css-extract-plugin
export default {"root":"D_tGs6ehtbZPgsJhKU2c","image":"hR4XUDBTSQadut22WWuX","loader":"BvbAHkZcZc0zJR7J8pob","link":"Wyb2lcYpR54Sl4AwwbGN","placeHolderShimmer":"ZMPNbVuEdXzTs8z40x2f"};